<script lang="ts">
  
</script>

<section class="pt-14">
  <div class="container mx-auto">
    <div class="flex justify-center">
      <div class="w-full">
        <div class="w-10/12 mx-auto text-center">
          <div class="four_zero_four_bg">
            <h1 class="text-center text-6xl text-gray-700">404</h1>
          </div>

          <div class="content_box_404 text-gray-700">
            <h3 class="text-xl font-bold">
              Look like you're lost
            </h3>

            <p class="text-gray-700">the page you are looking for is not available!</p>

            <a href="/" class="link_404">Go to Home</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<style lang="postcss">
  .four_zero_four_bg {
    background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
    height: 400px;
    background-position: center;
    h1 {
      font-size:80px;
    }
  }
  
  .link_404 {			 
	  color: #fff!important;
    padding: 10px 20px;
    background: #39ac31;
    margin: 20px 0;
    display: inline-block;
  }

	.content_box_404{ 
    margin-top:-50px;
  }
</style>